module.exports = __webpack_public_path__ + "static/media/join_us.df1707a7.png";